<script>
    import {getGPTransFunc} from "./gp-translations.js";

    let trans = getGPTransFunc("gp-printproject");

    export let items;
    export let imgDataUrl;
    export let printFunc;

    $: itemsLeft = items.length > 5 ? items.slice(0, Math.ceil(items.length / 2)) : items;
    $: itemsRight = items.length > 5 ? items.slice(Math.ceil(items.length / 2)) : [];
</script>

<div>
    <style>
        * {
            font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
        }

        .header {
            margin-bottom: 7px;
        }
        .header svg {
            width: 15vw;
            height: 7.5vw;
        }
        h3 {
            font-size: 22px;
        }

        table {
            border-collapse: collapse;
        }

        td {
            border-top: 1px solid #e8e8e8;
            padding: 3px;
            text-align: left;
        }

        tr:first-child td {
            border-top: none;
        }

        th {
            padding: 3px;
            text-align: left;
            text-transform: uppercase;
            font-size: 12px;
            border-bottom: 1px solid #aaa;
        }


        th:nth-child(2), td:nth-child(2) {
            text-align: right;
        }

        .tables {
            display: grid;
            grid-template-columns: 1fr 1fr;
            grid-gap: 7vw;
        }

        img {
            width: 100%;
            margin-bottom: 15px;
            border: 1px solid #ccc;
        }
    </style>
</div>

<div class="header">
<svg version="1.1"
	 xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:a="http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/"
	 x="0px" y="0px" width="1142px" height="504px" viewBox="0 0 1142 504" enable-background="new 0 0 1142 504" xml:space="preserve"
	>
<defs>
</defs>
<path fill="#49606B" d="M496.367,56.009c4.281,0,7.75-3.47,7.75-7.75V7.75c0-4.28-3.469-7.75-7.75-7.75h-40.508
	c-4.279,0-7.75,3.47-7.75,7.75v15.587H268.635v-7.322c0-2.533-2.054-4.588-4.587-4.588h-23.979c-2.533,0-4.588,2.055-4.588,4.588
	v7.322H56.008V7.75c0-4.28-3.47-7.75-7.75-7.75H7.75C3.469,0,0,3.47,0,7.75v40.509c0,4.28,3.469,7.75,7.75,7.75h15.587v179.473
	h-7.323c-2.533,0-4.588,2.055-4.588,4.588v23.979c0,2.533,2.055,4.588,4.588,4.588h7.323v179.473H7.75
	c-4.281,0-7.75,3.471-7.75,7.75v40.51c0,4.279,3.469,7.75,7.75,7.75h40.508c4.28,0,7.75-3.471,7.75-7.75v-15.588h179.473v7.322
	c0,2.533,2.055,4.588,4.588,4.588h23.979c2.533,0,4.587-2.055,4.587-4.588v-7.322h179.474v15.588c0,4.279,3.471,7.75,7.75,7.75
	h40.508c4.281,0,7.75-3.471,7.75-7.75v-40.51c0-4.279-3.469-7.75-7.75-7.75h-15.588V268.636h7.322c2.534,0,4.588-2.055,4.588-4.588
	V240.07c0-2.533-2.054-4.588-4.588-4.588h-7.322V56.009H496.367z M462.109,14h28.008v28.01h-28.008V14z M243.481,19.427h17.154
	v17.154h-17.154V19.427z M14,14h28.008v28.01H14V14z M19.426,243.482H36.58v17.154H19.426V243.482z M42.008,490.119H14v-28.01
	h28.008V490.119z M260.635,484.691h-17.154v-17.154h17.154V484.691z M490.117,490.119h-28.008v-28.01h28.008V490.119z
	 M484.689,260.636h-17.154v-17.154h17.154V260.636z M471.447,235.482h-7.324c-2.533,0-4.588,2.055-4.588,4.588v23.979
	c0,2.533,2.055,4.588,4.588,4.588h7.324v179.473h-15.588c-4.279,0-7.75,3.471-7.75,7.75v15.588H268.635v-7.322
	c0-2.533-2.054-4.588-4.587-4.588h-23.979c-2.533,0-4.588,2.055-4.588,4.588v7.322H56.008v-15.588c0-4.279-3.47-7.75-7.75-7.75
	H32.671V268.636h7.322c2.533,0,4.588-2.055,4.588-4.588V240.07c0-2.533-2.055-4.588-4.588-4.588h-7.322V56.009h15.587
	c4.28,0,7.75-3.47,7.75-7.75V32.671h179.473v7.323c0,2.533,2.055,4.588,4.588,4.588h23.979c2.533,0,4.587-2.055,4.587-4.588v-7.323
	h179.474v15.588c0,4.28,3.471,7.75,7.75,7.75h15.588V235.482z"/>
<path fill="#55BE8C" d="M597.921,164.88c0,20.102,6.701,32.691,27.412,32.691c8.324,0,14.416-2.234,19.898-5.888v-37.565h-15.229
	c-5.279,0-10.152-4.67-10.152-10.355c0-5.686,4.873-10.153,10.152-10.153h23.146c7.514,0,14.215,3.858,14.215,11.778v46.701
	c0,17.664-23.555,25.178-43.047,25.178c-33.504,0-48.732-20.711-48.732-52.387v-41.828c0-31.676,15.229-52.387,48.732-52.387
	c19.898,0,38.984,8.934,38.984,19.492c0,5.28-4.467,9.748-10.355,9.748c-3.857,0-5.076-1.421-8.121-3.25l-1.016-0.609
	c-5.482-3.654-11.371-5.686-18.477-5.686c-20.711,0-27.412,12.59-27.412,32.692V164.88z"/>
<path fill="#55BE8C" d="M741.472,148.027c0-11.979-6.092-17.868-18.682-17.868c-5.279,0-8.527,1.217-11.979,2.639l-3.857,1.625
	c-1.219,0.61-3.453,1.016-5.279,1.016c-5.889,0-8.326-4.67-8.326-8.936c0-10.761,15.635-15.025,31.473-15.025
	c27.412,0,38.58,14.418,38.58,41.422v41.218c0,5.077,2.029,5.889,5.076,6.499c4.264,0.812,6.092,3.451,6.092,7.31
	c0,5.686-4.266,8.527-11.98,8.527c-7.107,0-12.387-2.841-16.244-9.136c-7.514,6.498-16.447,9.746-27.615,9.746
	c-22.131,0-33.502-12.387-33.502-31.27v-0.609c0-20.305,12.588-30.66,37.969-30.66c6.295,0,12.387,0.813,18.275,2.438V148.027z
	 M706.955,185.388v0.609c0,8.121,4.061,12.791,15.229,12.791c6.902,0,12.994-2.029,19.289-7.105v-18.275
	c-5.889-1.42-12.59-2.233-17.666-2.233C709.593,171.175,706.955,177.673,706.955,185.388"/>
<path fill="#55BE8C" d="M813.144,137.265c0.203,1.828,0.406,3.25,0.406,4.67v64.976c0,5.889-4.873,10.356-10.965,10.356
	c-6.293,0-10.965-4.467-10.965-10.356v-64.976c0-5.684-0.811-8.731-2.842-11.775c-1.219-1.625-2.03-3.047-2.03-5.483
	c0-5.685,4.872-9.543,10.558-9.543c3.656,0,6.904,2.436,9.342,5.887c9.137-5.481,19.492-8.731,26.598-8.731
	c10.355,0,13.605,4.264,13.605,9.95c0,6.498-5.076,10.761-11.168,10.355C827.156,132.392,821.673,132.189,813.144,137.265"/>
<path fill="#55BE8C" d="M917.302,116.148v-37.36c0-5.482,3.857-9.951,10.965-9.951c6.904,0,10.965,4.469,10.965,9.951v112.286
	c0,4.263,1.219,6.701,4.467,9.542c1.422,1.625,2.234,3.25,2.234,5.483c0,6.295-5.279,9.746-10.152,9.746s-8.732-2.842-11.574-7.105
	c-9.34,5.076-18.479,8.527-28.631,8.527c-22.537,0-34.721-15.838-34.721-39.19v-24.365c0-24.162,8.73-41.422,36.143-41.422
	C903.496,112.291,909.994,113.306,917.302,116.148 M917.302,134.22c-6.498-2.438-13.604-3.451-17.664-3.451
	c-12.387,0-16.854,7.308-16.854,22.943v24.365c0,13.2,5.279,20.307,16.447,20.307c5.279,0,11.775-1.828,18.477-5.076
	c-0.406-1.625-0.406-3.047-0.406-4.266V134.22z"/>
<path fill="#55BE8C" d="M986.943,174.22v9.34c0,9.138,6.295,15.027,19.086,15.027c7.514,0,12.996-2.031,19.695-5.076
	c0.609-0.406,2.031-1.016,4.467-1.016c6.904,0,9.951,5.076,9.951,9.137c0,12.184-23.961,15.635-35.941,15.635
	c-24.975,0-39.188-15.026-39.188-34.721v-35.939c0-19.901,14.01-35.129,40.203-35.129c24.57,0,36.752,13.402,36.752,33.707
	c0,19.086-11.168,30.457-36.955,30.457C999.328,175.642,993.441,175.236,986.943,174.22 M1004.81,129.55
	c-11.369,0-17.867,6.092-17.867,15.838v11.978c6.902,0.813,14.822,1.219,17.867,1.219c11.574,0,15.432-5.482,15.432-14.01
	C1020.242,133.814,1014.759,129.55,1004.81,129.55"/>
<path fill="#55BE8C" d="M1085.822,206.912c0,5.686-3.654,10.152-10.965,10.152c-7.309,0-10.965-4.466-10.965-10.152v-65.18
	c0-8.933-1.42-9.34-2.639-11.369c-1.625-2.437-2.438-3.656-2.438-6.092c0-5.279,4.469-9.339,10.559-9.339
	c3.859,0,7.107,2.232,9.545,5.886c9.137-6.293,19.086-8.933,28.02-8.933c23.555,0,35.33,15.634,35.33,38.986v56.041
	c0,5.686-4.061,10.152-10.965,10.152c-7.105,0-10.963-4.466-10.963-10.152v-56.041c0-12.793-5.889-20.305-16.041-20.305
	c-6.092,0-12.387,2.233-19.088,6.293c0.406,1.828,0.609,3.453,0.609,4.873V206.912z"/>
<path fill="#55BE8C" d="M598.107,379.656v41.828c0,5.686-5.076,10.965-11.168,10.965c-5.889,0-11.168-5.076-11.168-10.965V299.451
	c0-6.496,5.889-12.182,12.793-12.182h29.848c35.939,0,48.732,22.334,48.732,46.498c0,29.441-19.088,45.889-48.732,45.889H598.107z
	 M598.107,358.945h20.305c17.26,0,26.396-8.121,26.396-25.381c0-12.59-4.873-25.381-26.396-25.381h-20.305V358.945z"/>
<path fill="#55BE8C" d="M719.523,432.042c-22.943,0-34.924-15.838-34.924-39.189v-56.041c0-5.686,3.857-9.949,10.965-9.949
	c6.904,0,10.965,4.264,10.965,9.949v56.041c0,12.996,5.279,20.307,15.838,20.307c6.092,0,12.588-2.031,19.086-5.482
	c-0.203-1.828-0.406-3.453-0.406-4.873v-65.992c0-5.686,3.654-9.949,10.965-9.949s10.965,4.264,10.965,9.949v68.021
	c0,7.107,1.625,7.92,3.654,10.762c1.219,1.422,2.234,3.047,2.234,5.482c0,5.889-5.076,9.746-10.355,9.746
	c-4.467,0-7.92-2.842-10.559-6.904C738.814,429.808,728.865,432.042,719.523,432.042"/>
<path fill="#55BE8C" d="M859.011,345.341l-47.107,65.787h39.188c6.092,0,10.559,4.264,10.559,9.746c0,5.28-4.467,9.543-10.559,9.543
	h-56.244c-5.889,0-11.168-4.67-11.168-10.762c0-2.029,0.406-4.061,2.031-6.293l47.107-66.195h-36.752
	c-5.686,0-10.355-4.264-10.355-9.543c0-5.686,4.67-9.746,10.355-9.746h53.809c6.09,0,11.369,3.857,11.369,10.355
	C861.244,340.468,860.634,343.107,859.011,345.341"/>
<path fill="#55BE8C" d="M948.146,345.341l-47.107,65.787h39.188c6.092,0,10.559,4.264,10.559,9.746c0,5.28-4.467,9.543-10.559,9.543
	h-56.244c-5.889,0-11.168-4.67-11.168-10.762c0-2.029,0.406-4.061,2.031-6.293l47.107-66.195h-36.752
	c-5.686,0-10.355-4.264-10.355-9.543c0-5.686,4.67-9.746,10.355-9.746h53.809c6.09,0,11.369,3.857,11.369,10.355
	C950.378,340.468,949.769,343.107,948.146,345.341"/>
<path fill="#55BE8C" d="M967.431,409.707V293.767c0-5.482,4.67-10.154,10.965-10.154c6.092,0,10.965,4.469,10.965,10.154v114.721
	c0,4.266,0.203,6.092,2.842,8.936c1.422,1.42,2.641,2.639,2.641,5.482c0,5.686-4.467,9.137-11.371,9.137
	C976.974,432.042,967.431,429.402,967.431,409.707"/>
<path fill="#55BE8C" d="M1034.839,388.996v9.34c0,9.139,6.295,15.027,19.086,15.027c7.514,0,12.996-2.031,19.695-5.076
	c0.609-0.406,2.031-1.016,4.467-1.016c6.904,0,9.951,5.075,9.951,9.137c0,12.184-23.961,15.635-35.941,15.635
	c-24.975,0-39.188-15.025-39.188-34.721v-35.939c0-19.9,14.01-35.129,40.203-35.129c24.57,0,36.752,13.402,36.752,33.707
	c0,19.086-11.168,30.457-36.955,30.457C1047.224,390.417,1041.337,390.011,1034.839,388.996 M1052.707,344.326
	c-11.369,0-17.867,6.092-17.867,15.838v11.979c6.902,0.813,14.822,1.219,17.867,1.219c11.574,0,15.432-5.482,15.432-14.01
	C1068.138,348.589,1062.656,344.326,1052.707,344.326"/>
<path fill="#55BE8C" d="M393.689,274.261c0-59.08-29.141-142.08-62.336-142.08c-6.697,0-13.228,3.381-19.391,9.26
	c7.891,12.449,12.143,26.918,12.143,41.898c0,13.27-3.412,26.336-9.771,37.869c5.982,11,9.189,23.422,9.189,36.045
	c0,29.674-17.238,55.389-42.223,67.682c9.866,14.119,24.77,19.568,41.326,20.871v21.799c0,11.834-2.914,47.334-2.914,47.334h23.28
	c0,0-2.914-38.096-2.914-47.334v-21.797C369.492,343.498,393.689,328.099,393.689,274.261"/>
<path fill="#55BE8C" d="M305.523,257.253c0-13.668-4.785-26.213-12.763-36.07c8.343-10.354,13.345-23.512,13.345-37.844
	c0-31.562-24.222-57.453-55.092-60.133c-1.168-18.984-16.927-34.025-36.207-34.025c-17.212,0-31.615,11.988-35.339,28.066
	c-3.043-0.541-6.17-0.838-9.368-0.838c-29.365,0-53.17,23.805-53.17,53.17c0,14.454,5.778,27.553,15.137,37.137
	c-13.279,11.928-21.638,29.227-21.638,48.482c0,35.984,29.169,65.154,65.154,65.154c3.621,0,7.166-0.309,10.625-0.875
	c5.383,9.641,12.482,22.988,14.158,29.158c4.551,16.752-4.623,66.303-4.623,66.303h28.271c0,0-4.136-21.723-3.89-55.326
	c0.084-12.066,4.099-23.783,6.631-28.322c2.914-5.227,9.642-12.451,14.24-17.098c2.34,0.291,4.721,0.451,7.139,0.451
	C279.828,314.644,305.523,288.949,305.523,257.253 M212.824,324.888c-0.24,0.537-0.453,1.162-0.646,1.846
	c-3.092-4.486-6.655-8.887-9.53-12.26c5.196-2.377,10.028-5.408,14.381-9.002c2.805,1.812,5.775,3.389,8.885,4.697
	C220.365,315.072,214.662,320.773,212.824,324.888"/>
</svg>
</div>

<img src="{imgDataUrl}" on:load={printFunc}>

{#if items.length}
<h3>{trans("Plant list")}</h3>

<div class="tables">
    <table>
        <tr>
            <th>{trans("Name")}</th>
            <th>{trans("Quantity")}</th>
        </tr>
        {#each itemsLeft as item}
            <tr>
                <td>{item.name}</td>
                <td>{item.count}</td>
            </tr>
        {/each}
    </table>

    {#if itemsRight.length}
    <table>
        <tr>
            <td>&nbsp;</td>
            <td>&nbsp;</td>
        </tr>
        {#each itemsRight as item}
            <tr>
                <td>{item.name}</td>
                <td>{item.count}</td>
            </tr>
        {/each}
    </table>
    {/if}
</div>
{/if}